
/**
 * @description
 * 로드맵 > 상세 페이지 썸네일
 */

import { mapGetters } from 'vuex';

import Thumbnail from '@/components/common/img/Thumbnail.vue';
import CourseFavorite from './CourseFavorite.vue';

export default {
  name: 'CourseThumbnail',
  components: { Thumbnail, CourseFavorite },
  computed: {
    ...mapGetters('course', ['thumbnailImage']),
  },
};
